if ( typeof CartForm !== 'function' ) {
    class CartForm extends HTMLElement {

        constructor(){
            super();
            this.ajaxifyCartItems();
            this.enforceMaxQuantityLimits();
        }

        async getCartToken() {
            const response = await fetch('/cart.js');
            const data = await response.json()
            const token = data.token
            return token
        }

        ajaxifyCartItems(){
            this.form = this.querySelector('form');
            const clearCartButton = this.form.querySelector('[data-clear-cart-button]')
            const deleteCouponButton = document.querySelector('[data-delete-coupon-button]')
            const couponForm = document.querySelector('[data-coupon-form]')
            if (clearCartButton && !clearCartButton.classList.contains('listener-bound')) {
                clearCartButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.removeCart();
                });
                clearCartButton.classList.add('listener-bound');
            }

            if (deleteCouponButton && !deleteCouponButton.classList.contains('listener-bound')) {
                deleteCouponButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.handleCoupon(true);
                })
                deleteCouponButton.classList.add('listener-bound');
            }

            if (couponForm && !couponForm.classList.contains('listener-bound')) {
                couponForm.addEventListener('submit', (e) => {
                    e.preventDefault();
                    this.handleCoupon();
                })
                couponForm.classList.add('listener-bound');
            }

            this.querySelectorAll('[data-js-cart-item]').forEach(item => {
                const remove = item.querySelector('.remove');
                if (remove && !remove.classList.contains('listener-bound')) {
                    remove.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.updateCartQty(item, 0);
                    });
                    remove.classList.add('listener-bound');
                }
        
                const qtys = item.querySelectorAll('.qty');
                qtys.forEach(qty => {
                    if (!qty.classList.contains('listener-bound')) {
                        qty.addEventListener('input', debounce(e => {
                            e.preventDefault();
                            e.target.blur();
                            this.updateCartQty(item, parseInt(qty.value));
                        }, 500));
                        qty.classList.add('listener-bound');
                    }
                })
            })
        }

        handleLoading(isLoading){
            if(isLoading){
                this.form.classList.add('processing');
                document.querySelector('#AjaxCartSubtotal').classList.add('processing')
                if ( this.querySelector('.alert') ) {
                    this.querySelector('.alert').remove();
                }
            } else {
                this.form.classList.remove('processing');
                document.querySelector('#AjaxCartSubtotal').classList.remove('processing');
            }
        }

        async handleCoupon(isDeleteRequest = false) {
            const inputVal = document.querySelector('[data-coupon-input]').value.trim()
            if(!isDeleteRequest && !inputVal){
                return
            }
            this.handleLoading(true)

            const query = `
                mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                    cartDiscountCodesUpdate(
                        cartId: $cartId
                        discountCodes: $discountCodes
                    ) {
                        cart {
                            discountCodes {
                                code
                                applicable
                            }
                            discountAllocations {
                                targetType
                                discountedAmount {
                                    amount 
                                }
                            }
                        }
                        userErrors {
                            field
                            message
                        }
                    }
                }
            `;
            const usercookie = await this.getCartToken();
        
            const discountCodes = isDeleteRequest ? [] : [inputVal];
        
            const variables = {
                cartId: `gid://shopify/Cart/${usercookie}`,
                discountCodes: discountCodes
            };
        
            const url = '/api/2024-10/graphql.json';
            const grapqlToken = 'e5fd9b0dc32a55a9c9176b26181860b7';
        
            const headers = new Headers();
            headers.append('X-Shopify-Storefront-Access-Token', grapqlToken);
            headers.append('Content-Type', 'application/json');
        
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ query, variables }),
                    headers: headers
                });
        
                const result = await response.json();
        
                if (result.data.cartDiscountCodesUpdate.userErrors.length > 0) {
                    console.error('GraphQL User Errors:', result.data.cartDiscountCodesUpdate.userErrors);
                    this.showCouponError();
                    this.handleLoading(false);
                    return;
                }
        
                const isApplicable = result.data.cartDiscountCodesUpdate.cart.discountCodes.some(
                    (code) => code.applicable
                );
        
                const isShippingCode = result.data.cartDiscountCodesUpdate.cart.discountAllocations.some(
                    (allocation) =>
                        allocation.targetType === 'SHIPPING_LINE' &&
                        +allocation.discountedAmount.amount > 0
                );
        
                // Yeni eklenen event

                const event = new CustomEvent('coupon-updated', {
                    detail: {
                        isApplicable,
                        discountCodes: result.data.cartDiscountCodesUpdate.cart.discountCodes
                    }
                });
                window.dispatchEvent(event);
        
                if (isApplicable && isShippingCode) {
                    console.warn('Shipping coupons can only be applied at checkout.');
                    this.showCouponError('shipping');
                    this.handleLoading(false);
                    return;
                }

                if (isDeleteRequest || isApplicable) {
                    console.log('Coupon applied successfully, refreshing cart...');
                    this.reRenderCart();
                } else {
                    console.warn('Coupon application failed.');
                    await this.handleCoupon(true);
                    this.showCouponError();
                }
            } catch (error) {
                console.error('Error while applying coupon:', error);
                this.showCouponError();
            } finally {
                this.handleLoading(false);
            }
        }


        showCouponError(type = 'default'){
            document.querySelector(`[data-coupon-${type}-error]`).classList.remove('hidden')
            setTimeout(() => {
                document.querySelector(`[data-coupon-${type}-error]`).classList.add('hidden')
            }, 4500);

            if (window.Alpine) {
                const cartCouponEl = document.querySelector('[x-data="cartCoupon"]');
                if (cartCouponEl) {
                    Alpine.evaluate(cartCouponEl, 'showCouponErrorModal = true');
                }
            }
        }

        removeCart(){
            this.form.classList.add('processing');
            if ( this.querySelector('.alert') ) {
                this.querySelector('.alert').remove();
            }

            fetch('/cart/clear', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            })
            .then((res) => res.json())
            .then((data) => {
                if(data.item_count !== 0){
                    console.warn(e);
                    let alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    alert.textContent = KROWN.settings.locales.cart_general_error;
                    this.form.prepend(alert);
                }
                this.reRenderCart()
            })
            .catch(e => {
                console.warn(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                this.form.prepend(alert);
            })
        }

        updateCartQty(item, newQty) {
            this.handleLoading(true);

            const body = JSON.stringify({
                id: item.dataset.id,
                quantity: newQty
            });

            new Promise(resolve => setTimeout(resolve, 500))
                .then(() => fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body
                }))
                .then(response => response.json())
                .then(response => {
                    if (response.status === 422) {
                        // wrong stock logic alert
                        const alert = document.createElement('span');
                        alert.classList.add('alert', 'alert--error');
                        alert.textContent = response.message;
                        this.form.prepend(alert);
                    }
                    this.reRenderCart();
                })
                .catch(e => {
                    console.warn(e);
                    const alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    alert.textContent = 'Failed to update cart quantity.';
                    this.form.prepend(alert);
                })
                .finally(() => {
                    this.handleLoading(false);
                })
        }

        reRenderCart(alert = null){
            this.cleanUpEventListeners();

            // 300ms delay error'u görünür kılmak için eklenmiştir.
            new Promise(resolve => setTimeout(resolve, 300))
                .then(() => fetch('?section_id=helper-cart'))
                .then(response => response.text())
                .then(text => {
                    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                    const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                    const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                    const cartItems = document.getElementById('AjaxCartForm');
                    cartItems.innerHTML = cartFormInnerHTML;
                    document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

                    cartItems.ajaxifyCartItems();

                    document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
                        elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                    });
                    document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
                        elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                    });

                    if (alert !== null) {
                        this.form.prepend(alert);
                    } 
        
                    const event = new Event('cart-updated');
                    this.dispatchEvent(event);
                })
                .catch(e => {
                    console.log(e);
                    const alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    alert.textContent = 'An error occurred while updating the cart.';
                    this.form.prepend(alert);
                })
                .finally(() => {
                    this.handleLoading(false);
                });
        }
        
        cleanUpEventListeners() {
            const removeButtons = this.form.querySelectorAll('.remove');
            removeButtons.forEach(button => {
                button.removeEventListener('click', this.removeCart);
            });
        
            const qtyInputs = this.form.querySelectorAll('.qty');
            qtyInputs.forEach(input => {
                input.removeEventListener('input', this.updateCartQty);
            });
        }

        async enforceMaxQuantityLimits() {
            const removeItems = document.querySelectorAll("[data-remove-metafield]")
            if(!removeItems.length) return;
            const currentUrl = window.location.href;
            let message;


            const updates = {};
            const adjustedItems = []; // container için gerekli

            removeItems.forEach((div) => {
                const id = div.getAttribute("data-item-key");
                const maxQuantity = parseInt(div.getAttribute("data-max-quantity"));
                const currentQuantity = parseInt(div.getAttribute("data-current-qty"));
                const itemTitle = div.getAttribute("data-item-title");

                if(currentQuantity > maxQuantity){
                    updates[id] = maxQuantity;
                    adjustedItems.push({ title: itemTitle, max: maxQuantity }); // Store item info
                }
            })

            if(Object.keys(updates).length > 0){
                try {
                    this.handleLoading(true);

                    fetch(KROWN.settings.routes.cart_url + '/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                        body: JSON.stringify({updates})
                    })
                    .then(response => response.json())
                    .then(response => {
                        if ( response.status == 422 ) {
                            alert = document.createElement('span');
                            alert.classList.add('alert', 'alert--error');
                            if ( typeof response.description === 'string' ) {
                                alert.innerHTML = response.description;
                            } else {
                                alert.innerHTML = response.message;
                            }
                        }
                        this.reRenderCart();
                    }, 300)
                } catch (error) {
                    console.log(error)
                } finally{
                    this.handleLoading(false);
                }
            }
        }
    } 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
        customElements.define('cart-form', CartForm);
    }

}

if ( typeof CartProductQuantity !== 'function' ) {

    class CartProductQuantity extends HTMLElement {
        constructor(){
            super();
            this.querySelector('.qty-minus')?.addEventListener('click', this.changeCartInput.bind(this));
            this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
        }
        changeCartInput(){
            const input = this.querySelector('.qty')
            const isAdd = parseInt(input.value) > parseInt(input.dataset.oldvalue)
            document.dispatchEvent(new CustomEvent('cart-item-update-holly', {
                detail: {
                    item: this.closest('[data-js-cart-item]'),
                    isAdd: isAdd
                }
            }))
            setTimeout(()=>{
                document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
            }, 50);
        }
    }

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
        customElements.define('cart-product-quantity', CartProductQuantity);
    }

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

    window.refreshCart = () => {
        
        fetch('?section_id=helper-cart')
            .then(response => response.text())
            .then(text => {

            const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
            const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
            const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
            const cartItems = document.getElementById('AjaxCartForm');
            cartItems.innerHTML = cartFormInnerHTML;
            cartItems.ajaxifyCartItems();

            document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
            });
            document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
            })
            
            document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
            if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
                document.querySelector('[data-js-site-cart-sidebar]').show();
            }

            if ( document.querySelector('cart-recommendations') ) {
                document.querySelector('cart-recommendations').innerHTML = '';
                document.querySelector('cart-recommendations').generateRecommendations();
            }

        })

    }

}
